module.exports = __webpack_public_path__ + "static/google-maps-3f52a778db4b741e7773eb753565a1f6.png";